<template>
  <div class="news-headline-wrapper">
    <PulseLoader
      v-if="loading"
      :loading="loading"
      color="#F5A623"
      size="1.5rem"
      style="margin:5rem auto;text-align:center"
    ></PulseLoader>

    <div v-if="!loading && !errorLoading" class="headline-carousel-wrapper">
      <carousel
        :navigationEnabled="true"
        :centerMode="false"
        :scrollPerPage="true"
        :paginationEnabled="false"
        :perPageCustom="[[0,1], [768, 2], [992, 4], [1200, 5]]"
      >
        <slide
          v-for="(headline, index) in assetHeadlinesList"
          :key="index"
          class="headline-news-slide"
        >
          <div class="slide-wrapper">
            <p class="headline-source">
              {{ headline.source }}
              <a
                :href="headline.url"
                class="news-outlink"
                target="_blank"
                rel="noopener noreferrer"
              >
                <v-icon name="external-link"></v-icon>
              </a>
            </p>

            <div class="headline-image-wrapper">
              <img
                id="headline-image"
                class="rounded-lg"
                :src="headline.imageUrl"
                :alt="headline.title"
              />
            </div>

            <p class="headline-title">{{ headline.title | formatHeadlineTitle(headline.source) }}</p>

            <!-- <p id="headline-content">{{ headline.description }}</p> -->
            <p class="headline-publish-date">{{ headline.publishedAt | formatPublishDate}}</p>
          </div>
        </slide>
      </carousel>
    </div>

    <div
      v-if="errorLoading"
      class="error-loading row"
    >Oops, news headlines will be back shortly. Please try again later...</div>
  </div>
</template>

<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  name: "news-headline-carousel",

  components: {
    PulseLoader
  },

  data() {
    return {
      loading: true,
      errorLoading: false,
      assetHeadlinesList: []
    };
  },

  mounted() {
    // get news headlines & update headline news every 5 minutes
    this.getAssetHeadlines();
    setInterval(this.getAssetHeadlines, 1000 * 60 * 5);
  },

  filters: {
    formatHeadlineTitle: (title, source) => {
      const sourceIndex = title.lastIndexOf("-");

      // delete redundant source name from title,
      if (sourceIndex > 0) {
        let titleSource = title
          .substr(sourceIndex + 1)
          .trim()
          .toLowerCase();
        source = source.toLowerCase();
        if (titleSource.includes(source) || source.includes(titleSource)) {
          title = title.substr(0, sourceIndex).trim();
        }
      }

      // cut title if too long
      return title.length > 120 ? title.substr(0, 117) + "..." : title;
    },

    formatPublishDate: publishAt => {
      if (!publishAt) return "today";
      const currentTime = new Date().getTime();
      const publishAtTime = Date.parse(publishAt);
      return Math.floor((currentTime - publishAtTime) / 3600000) + "hr ago";
    }
  },

  methods: {
    getAssetHeadlines() {
      this.loading = true;
      this.errorLoading = false;
      this.$store
        .dispatch("getAssetHeadlines")
        .then(res => {
          this.assetHeadlinesList = res.data;
          // console.log("get lastest headlines...", res.data);
          this.loading = false;
        })
        .catch(err => {
          console.log("getAssetHeadlines() ERROR: ", err);
          this.loading = false;
          this.errorLoading = true;
        });
    }
  }
};
</script>

<style scoped>
.news-headline-wrapper {
  min-height: 4rem;
  border-bottom: 1px solid #d8d8d8;
  padding-bottom: 1rem;
  margin-bottom: 1rem;
}

.slide-wrapper {
  padding: 0 1rem;
  color: #4a4a4a;
}

.headline-carousel-wrapper {
  padding-left: 1.8rem;
  padding-right: 1.8rem;
}

.headline-source {
  font-family: avenir;
  font-size: 0.725rem;
  font-weight: bold;
}

.icon-external-link {
  width: 1rem;
  float: right;
  color: #000000;
  opacity: 0.5;
}

.headline-title {
  font-family: Raleway;
  font-weight: bold;
  font-size: 0.9rem;
  margin-top: 0.5rem;
  margin-bottom: 0.2rem;
}

.headline-image-wrapper {
  text-align: center;
  background-color: #d8d8d8;
  margin-top: 0.5rem;
}

.headline-image-wrapper > img {
  height: 10rem;
  width: 100%;
  object-fit: cover;
  overflow: hidden;
}

/* .headline-content {
  font-family: Raleway;
  margin-top: 0.5rem;
  font-size: 14px;
  letter-spacing: 0.41px;
} */

.headline-publish-date {
  font-family: Avenir;
  opacity: 0.8;
  font-size: 0.8rem;
  text-align: left;
  padding-left: 0.1rem;
}

.error-loading {
  margin: 3rem;
  text-align: center;
}

@media (min-width: 768px) {
  .headline-carousel-wrapper {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .error-loading {
    margin: 3.5rem;
  }
}

@media (min-width: 992px) {
  .headline-carousel-wrapper {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .error-loading {
    margin: 4rem;
  }
}

@media (min-width: 1200px) {
  .headline-carousel-wrapper {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .headline-title {
    font-size: 1rem;
  }

  .error-loading {
    margin: 5rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/insight-page-components/news-headline-carousel.vue